<template>
    <ContentOrLoading>
        <ShowSvgSectionComponent
            v-if="svg"
            :seccion="seccion"
            :zona_id="zona_id"
            :svg="svg"
            :zonas="zonas"
            :relaxedGuards="true"
            @clickZona="clickRegion"
        />
    </ContentOrLoading>
</template>

<script setup>
    import { useAbonosSvg } from '@/composables/admin/abonos/useAbonosSvg'
    import ShowSvgSectionComponent from '@/components/common/svg/secciones/ShowSvgSectionComponent.vue'

    const props = defineProps({
        zonas: {
            type: Array,
            required: true
        },
        seccion: {
            type: Object,
            required: true
        },
        zona_id: {
            type: Number,
            required: false
        }
    })

    const emit = defineEmits(['clickZona'])

    const { svg } = useAbonosSvg({
        svgAlias: 'back.abonos.taquilla.recinto.secciones.regiones.svg',
        extraParams: { seccion_id: props.seccion.id }
    })

    function clickRegion(zona) {
        emit('clickZona', zona)
    }
</script>
